import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import { Field, getFormValues, reduxForm } from "redux-form";
import SelectButtonField from "../../commonfields/SelectButtonField";
import { CheckboxGroup, MultipleSelectField } from "common-fields";
import SelectButtonField2 from "../../commonfields/SelectButtonField2";

const CaseFilterLeads = (props: any) => {
  const [lorSelector, setLorSelector] = React.useState(false);
  // const appType = [{value: "General",text: "General",},
  //   {value: "LOR",text: "LOR",},];

  const handleFormSubmit = (values: any) => {
      const caseTypes = values.caseType ?
       props.appTypeObj.filter((m:any)=>m.value == values.caseType).map((m:any)=>m.value) :[];
      const caseManagers = values.caseManager
      ? values.caseManager?.map((m: any) => m.value)
      : [];
      const status = values.statusType ? values.statusType : [];
      const lor = values.lor
      ? values.lor?.map((m: any) => m.value)
      : [];
      props.getCasesByOrgWithFilters(caseManagers,caseTypes, status, lor);
    
    
  };
  const onChangeType = (e: any) => {
    
    // props.change("selectLOR", "")
    if (e == "LOR") {
      setLorSelector(true)
    } else {
      setLorSelector(false)
    }
  }
  const clearAllCases = () => { 
    props.change("caseManager", [])
    props.change("caseType", "")
    props.change("statusType", [])
    props.change("lor", [])
    props?.getCasesByOrgWithFilters([],[], [], []);
    props?.clearSelection()
  }
  useEffect(() => {
    if (props?.selectedFiltersData?.caseType?.includes('LOR')) {
      setLorSelector(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <form onSubmit={props.handleSubmit(handleFormSubmit)} className="filterFormModal">
      <Row>
        <Col md="7" className="bizType statesWrap">
          <Field
          name="caseManager"
          component={MultipleSelectField}
          type="text"
          label="Case Manager"
          helpText="Case Manager"
          placeholder="Select Manager(s)"
          values={props.managerFilterData}
        />
          <Field
          component={SelectButtonField2}
          name={"caseType"}
          label={"Case Type"}
          HelpText={""}
          values={props.appTypeObj || []}
          onChange={(e: any) => { onChangeType(e)}}
        />
            {lorSelector? 
            <Field
            isRequired={true}
            component={MultipleSelectField}
            name={"lor"}
            label={"LOR Company:"}
            HelpText={"LORCompany"}
            values={props?.allLORClients}
          />
          :''}
        </Col>
        <Col md="5">
          {" "}
          <Field
            name="statusType"
            component={CheckboxGroup}
            type="text"
            label="Status"
            helpText="Status"
            options={props.caseStatusFilterData}
          />
        </Col>
      </Row>
      <div className="filterBtns">
        <Button onClick={clearAllCases}>Clear All</Button>
        <Button color="primary"> Apply</Button>
      </div>
    </form>
  );
};

const mapStateToProps = (state: any, props: any) => ({
  initialValues: {
    statusType: props?.trackerName === "caseTracker" ? 
      props?.selectedFiltersData?.caseStatus || [] : 
      props?.selectedFiltersData?.status || [],
    caseManager: props?.managerFilterData ? 
      props?.managerFilterData?.filter((each: any) => 
        props?.selectedFiltersData?.caseManager?.includes(each?.value)) || [] : [],
    caseType: props?.selectedFiltersData?.caseType || [],
    lor: props?.allLORClients ? 
      props?.allLORClients?.filter((each: any) => 
        props?.selectedFiltersData?.lor?.includes(each?.value)) || [] : [],
  },
  formValues: getFormValues("CaseFilterForm")(state),
});

export default connect(mapStateToProps)(
  reduxForm({
    form: "CaseFilterForm", // a unique identifier for this form
    enableReinitialize: true,
  })(CaseFilterLeads)
);
